module.exports = __webpack_public_path__ + "img/digitalticket_number.8eadc0f3.svg";